import { Component } from 'react';

import { Button, styled } from '@mui/material';

import { isV2PermissionsEnabled } from '../../helpers/featureFlags/isV2PermissionsEnabled';
import { hasAnyRole, requestSurveyAllowedRoles } from '../../utils/permissions';
import { EMAILS } from '../common/headers';
import PopupModal from '../common/PopupModal/PopupModal';
import 'react-toastify/dist/ReactToastify.css';
import './../RequestMarketData/RequestMarketDataModal.css';
import { toastify } from '../common/Toastify';
import { StyledTooltip } from '../common/Tooltip/Tooltip';
import RequestSurveyModal from '../RequestSurvey/RequestSurveyModal';

export const RequestSurveyButton = styled(Button)({
  boxSizing: 'border-box',
  background: '#003f2d !important',
  fontSize: '18px',
  padding: '0 20px',
  height: '48px',
  color: '#fff !important',
  fontFamily: 'Calibre-R',
  lineHeight: '20px',
  borderRadius: 0,

  '&:disabled': {
    background: '#e4e4e4 !important',
    color: '#939393 !important',
  },
});

export default class RequestSurveyBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newproduct: null,
      products: [],
      isModelOpen: false,
      isSurveyModalOpen: false,
      isDisabled: false,
      modelOpen: false,
    };
  }
  closeSurveyModal = () => {
    this.setState({ isSurveyModalOpen: false });
  };
  showSurveyModal = () => {
    const res_user = JSON.parse(sessionStorage.getItem('USER_DATA'));

    if (!res_user && !res_user.ClientNames) {
      toastify({
        type: 'error',
        title: 'Client not assigned. Please contact: ' + EMAILS.adminEmail,
        position: 'top-center',
        hideProgressBar: true,
        autoClose: true,
      });
    } else {
      this.setState({ isSurveyModalOpen: true });
    }
  };

  render() {
    const requestSurveyEnabled = isV2PermissionsEnabled()
      ? hasAnyRole(requestSurveyAllowedRoles)
      : true;

    return (
      <div className="surveyDiv">
        <StyledTooltip
          title={this.props.IsRequestButtonEnabled ? '' : 'Zoom in to request a survey'}
        >
          <RequestSurveyButton
            id="checkout-button"
            disabled={!this.props.IsRequestButtonEnabled}
            onClick={this.showSurveyModal}
          >
            Request survey for all properties found
          </RequestSurveyButton>
        </StyledTooltip>

        {this.state.isSurveyModalOpen && (
          <PopupModal open={this.state.isSurveyModalOpen} onClose={this.closeSurveyModal}>
            <RequestSurveyModal
              close={this.closeSurveyModal}
              centerData={this.props.centerData}
              providerdata={this.props.providerdata}
              draw={this.props.draw}
              polygonData={this.props.polygonData}
              handleClearPolygonsState={this.props.handleClearPolygonsState}
            />
          </PopupModal>
        )}
      </div>
    );
  }
}
